import AircraftModel from "../aircraft/AircraftModel";
import Attack from "./Attacks";

class FalseInformationAttack extends Attack {
    /**
     * @param {number} startTimestamp
     */
    constructor(startTimestamp) {
        super(startTimestamp);

        /**
         * Counter to keep track when to give false information and when to give real information
         * 
         * @type {number}
         * @default 0
         * @private
         * @memberof FalseInformationAttack
         */
        this.timePassed = 0;

        /**
         * How often the false information should be given
         * 
         * 2=often,  40=long time
         * 
         * @type {number}
         * @default 10
         * @private
         * @memberof FalseInformationAttack
         */
        this.switchingTime = 10;

        /**
         * The false altitude of the aircraft
         * 
         * @type {number}
         * @default 0
         * @private
         * @memberof FalseInformationAttack
         */
        this.falseAlitude = 0;

        /**
         * The false speed of the aircraft
         * 
         * @type {number}
         * @default 0
         * @private
         * @memberof FalseInformationAttack
         */
        this.falseSpeed = 0;

        this.init();
    }

    init() {
        super.init();
        this.falseAlitude = Math.round(Math.floor(Math.random() * (400 - 50) + 50) / 10) * 10;
        this.falseSpeed = Math.floor(Math.random() * (60 - 28) + 28);
    }

    end(endTimestamp) {
        super.end(endTimestamp)
    }

    /**
     * Update the attack data
     * 
     * @param {AircraftModel} aircraftModel 
     */
    update(aircraftModel) {

        if (aircraftModel.isEstablishedOnCourse()) {
            // console.error("FalseInformationAttack: Aircraft is on final, but should not be. Lets remove the aircraft from the game.");
            // If this works as we want, we should remove the aircraft from the game. But not for this attack for those who removal applies to. 
            // This can be done with a EVENT_BUS trigger to AttackController that handles it, where aircraftController os avavilbe.
        }

        //TODO: Implement the logic to update the attack data, right now it is set once in the initAttackData method //jonsv200

        if(this.timePassed > 10000){
            this.resetTimePassed();             //resets the value. So it does not count forever.
        }
    }

    /**
     * Get the false information, if the condition is met
     * 
     * @param {number} aircraftSpeed - the speed of the aircraft
     * @param {number} aircraftAltitude - the altitude of the aircraft
     * @returns {number} - the false altitude and speed of the aircraft
     * @memberof FalseInformationAttack
     * @method getFalseInformation
     * @public
     */
    getFalseInformation(aircraftSpeed, aircraftAltitude) {
        this.timePassed++;
        //Timepassed 0-10 --> Standard values.      Timepassed 10-20 --> Fake Values
        if ((this.timePassed % this.switchingTime) < (this.switchingTime / 2)) {
            return [this.falseAlitude, this.falseSpeed];
        }
        return [aircraftAltitude, aircraftSpeed];
    }

    /**
     * Reset the time passed
     * 
     * @memberof FalseInformationAttack
     * @method resetTimePassed
     * @private
     */
    resetTimePassed() {
        this.timePassed = 0;
    }

    /**
     * Set the switching time
     * 
     * @param {number} time - the time to switch the false information
     * @memberof FalseInformationAttack
     * @method setSwitchingTime
     * @public
     */
    setSwitchingTime(time) {
        this.switchingTime = time;
    }

}

export default FalseInformationAttack;